import React from 'react';

import styles from './list-item.scss';

export const ListItem: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles.tile}>
    <div className={styles.contentWrapper}>
      {children}
    </div>
  </div>;
};
